import apiClient from './apiClient';

export default {
  fetchBlocksController: null,
  fetchBlockItemController: null,
  fetchBlocks({ params } = {}) {
    this.fetchBlocksController?.abort();
    this.fetchBlocksController = new AbortController();
    const { signal } = this.fetchBlocksController;
    return apiClient.get('/admin/marketing/blocks', { params, signal });
  },

  fetchBlockItem({ id }) {
    this.fetchBlockItemController?.abort();
    this.fetchBlockItemController = new AbortController();
    const { signal } = this.fetchBlockItemController;
    return apiClient.get(`/admin/marketing/blocks/${id}`, { signal })
      .catch((err) => {
        if (err?.message !== 'canceled') {
          return Promise.reject(err);
        }
      });
  },
  createBlockItem: ({ data }) => apiClient.post('/admin/marketing/block', data),
  updateBlockItem: ({ id, data }) => apiClient.patch(`/admin/marketing/block/${id}`, data),

};
